// src/pages/expense/_shared/vehicles.js
// ✅ 유류비(fuel_cost) 차량번호/차종 자동완성용 공용 차량 마스터 — 4개 사업
// 공용 위치(경영팀/환경종합/환경소독/용역 전부 여기서 가져다 쓴다). 렌트/신규
// 차량 등 목록에 없는 경우를 위해 자동완성은 어디까지나 "보조"이고, 직접 입력은
// 항상 가능하다(ExpenseDraftNew.jsx의 carNumber/carModel input은 자유 입력 유지).
export const VEHICLES = [
  { number: "104머9770", model: "코란도", business: "경영팀" },
  { number: "821로3826", model: "포터", business: "환경/종합" },
  { number: "174나3702", model: "레이", business: "환경/소독" },
  { number: "817나6483", model: "특장차량", business: "용역사업" },
];
